import { useState, useCallback } from "react";
import { authenticatedRequest } from "../api/clients";
import { ENDPOINTS } from "../api/endpoints";

export const useGetUser = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [data, setData] = useState(null);

  const getCurrentUser = useCallback(async (user_id) => {
    try {
      setLoading(true);
      setError(null);

      const response = await authenticatedRequest.get(
        ENDPOINTS.USER.USER_PROFILE(user_id)
      );
      const result = response.data.data;

      setData(result);
      return result;
    } catch (err) {
      setError(err.response?.data?.message || err.message);
      throw err;
    } finally {
      setLoading(false);
    }
  }, []);

  return { getCurrentUser, loading, error, data };
};
export const useUpdateUser = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const updateUserProfile = useCallback(async (user_id, formData) => {
    try {
      setLoading(true);
      setError(null);

      const response = await authenticatedRequest.patch(
        ENDPOINTS.USER.UPDATE_PROFILE(user_id),
        formData
      );

      return response.data.data;
    } catch (err) {
      setError(err.response?.data?.message || err.message);
      throw err;
    } finally {
      setLoading(false);
    }
  }, []);

  return { updateUserProfile, loading, error };
};

export const useDeleteUser = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const deleteUserProfile = useCallback(async (user_id) => {
    try {
      setLoading(true);
      setError(null);

      const response = await authenticatedRequest.delete(
        ENDPOINTS.USER.DELETE_PROFILE(user_id)
      );

      return response.data.data;
    } catch (err) {
      setError(err.response?.data?.message || err.message);
      throw err;
    } finally {
      setLoading(false);
    }
  }, []);

  return { deleteUserProfile, loading, error };
};
